// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z73i","placeholdersHeader":"styles_placeholdersHeader__1OzE_","editorStyle":"styles_editorStyle__LRh-q","placeholdersBox":"styles_placeholdersBox__Lio9B"};